export const selectFile = async (accept?: string | Array<string>) => {
    return new Promise<File | null>((resolve) => {
        const element = document.createElement('input')
        element.type = 'file'
        element.hidden = true

        if (accept) {
            if (Array.isArray(accept)) {
                element.accept = accept.join(',')
            } else {
                element.accept = accept
            }
        }

        element.addEventListener('cancel', () => {
            resolve(null)

            element.remove()
        })

        element.addEventListener('change', () => {
            if (element.files?.length) {
                resolve(element.files[0])
            } else {
                resolve(null)
            }

            element.remove()
        })

        element.click()
    })
}
